import { MfsLogo } from "@App/Components/atoms/whitelabel/logos/MfsLogo";
import { RepareoLogo } from "@App/Components/atoms/whitelabel/logos/RepareoLogo";
import type { Config } from "@App/configs/interfaces";

/**
 * Configuration for the MFS Opal whitelabel.
 * Extends the default configuration with specific settings for MFS Opal.
 */
export const config: Partial<Config> = {
  slug: "mfs-opal",
  navbar: {
    logos: {
      right: {
        component: <MfsLogo />,
      },
      left: {
        component: <RepareoLogo />,
      },
    },
    backToPartnerButton: {
      url: "https://www.mobilize-fs.de/",
    },
  },
  reviews: {
    show: true,
  },
};

export default config;
